"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checks that number is an integer
 */


var BigIntegerValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(BigIntegerValidator, _Validator_1$Validato);

  function BigIntegerValidator() {
    _classCallCheck(this, BigIntegerValidator);

    return _possibleConstructorReturn(this, _getPrototypeOf(BigIntegerValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
  }

  _createClass(BigIntegerValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!value.isInteger()) {
        return new ValidationResult_1.ValidationError(BigIntegerValidator.NOT_INTEGER_ERROR, value);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return BigIntegerValidator;
}(Validator_1.Validator);

exports.BigIntegerValidator = BigIntegerValidator;
BigIntegerValidator.NOT_INTEGER_ERROR = 'NOT_INTEGER';